import React from 'react';
import "./index.css";

export default function Work() {
    return (
        <section id="work" className="section is-medium">
            <p className="title is-family-code has-text-green">Some Things I've Built</p>
            <div className="columns is-mobile">
                <div className="column is-11 is-offset-1">
                    <div className="notification is-primary">
                        <p className="bd-notification title is-2 has-text-light is-family-code">Algomaster App</p>
                        <p className='is-family-code'>
                            Algomaster is an educational app that helps users learn data structures and algorithms more easily through interactive visualizations. 
                        </p>
                        <p className='is-family-code mt-2'>
                            For access or beta testing on Android, please contact me at: <strong>mandgenikhil@gmail.com</strong>
                        </p>
                        <br />
                        <a href="mailto:mandgenikhil@gmail.com" className='button btn is-family-code'>
                            <span className="icon is-small">
                                <i className="fa fa-lg fa-envelope"></i>
                            </span>
                            <span className='is-family-code'>Contact Me</span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}
